"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MapPopup = exports.MapPopupOptions = void 0;
var Style_1 = require("ol/style/Style");
var Overlay_1 = require("ol/Overlay");
var Select_1 = require("ol/interaction/Select");
var Fill_1 = require("ol/style/Fill");
var Circle_1 = require("ol/style/Circle");
var Stroke_1 = require("ol/style/Stroke");
var MapPopupOptions = /** @class */ (function () {
    function MapPopupOptions(minZoomLevel, maxToolTipCount) {
        if (maxToolTipCount === void 0) { maxToolTipCount = 8; }
        this.minZoomLevel = minZoomLevel;
        this.maxToolTipCount = maxToolTipCount;
    }
    return MapPopupOptions;
}());
exports.MapPopupOptions = MapPopupOptions;
var MapPopup = /** @class */ (function () {
    function MapPopup(map, recordTypeResource, toolTipProvider, options) {
        var _this = this;
        this.map = map;
        this.recordTypeResource = recordTypeResource;
        this.toolTipProvider = toolTipProvider;
        this.options = options;
        this.initialised = false;
        this.init = function () {
            if (!_this.initialised) {
                _this.addPopupOverlay();
                _this.addSelectFeatures();
                _this.initialised = true;
            }
        };
        this.onZoomChanged = function (args) {
            console.log("Map popup zoom level changed: " + args.zoomLevel);
            _this.zoomLevel = args.zoomLevel;
        };
        this.popupIsOpen = function () {
            return _this.popupContainer.css('display') === 'block';
        };
        this.addPopupOverlay = function () {
            var mapDiv = $('#map');
            _this.popupContainer = $("<div>", { id: "popup", class: "ol-popup" });
            _this.popupCloser = $("<div>", { id: "popup-closer", class: "ol-popup-closer", href: "#" });
            _this.popupContent = $("<div>", { id: "popup-content", class: "ol-popup-content" });
            mapDiv.append(_this.popupContainer);
            _this.popupContainer.append(_this.popupCloser);
            _this.popupContainer.append(_this.popupContent);
            _this.overlay = new Overlay_1.default({
                autoPan: true,
                element: _this.popupContainer[0]
            });
            //Add a click handler to hide the popup.
            _this.popupCloser.on("click", function () {
                var f = _this.selectFeatures.getFeatures();
                if (f && f.getLength() > 0) {
                    f.clear();
                }
                _this.overlay.setPosition(undefined);
                _this.popupContainer.css('display', 'none');
                _this.popupCloser.blur();
                return false;
            });
            _this.map.olMap.addOverlay(_this.overlay);
        };
        this.addSelectFeatures = function () {
            _this.selectFeatures = new Select_1.default({
                filter: _this.CanSelectFeature,
                multi: true,
                style: new Style_1.default({
                    fill: new Fill_1.default({
                        color: [66, 94, 143, 0.60]
                    }),
                    stroke: new Stroke_1.default({
                        color: [193, 100, 100, 0.8],
                        width: 5
                    }),
                    image: new Circle_1.default({
                        radius: 15,
                        fill: new Fill_1.default({
                            color: 'rgba(66, 94, 143, 0.80)'
                        }),
                        stroke: new Stroke_1.default({
                            color: 'rgba(193, 100, 100, 0.8)',
                            width: 3
                        })
                    })
                })
            });
            _this.selectFeatures.on('select', function (obj) {
                //e.selected is sometimes empty even though a feature has been visibily selected on the map
                //getFeatures() seems to more reliable
                _this.onFeaturesSelected(obj.target.getFeatures().getArray(), obj.mapBrowserEvent.coordinate);
            });
            _this.map.olMap.addInteraction(_this.selectFeatures);
        };
        this.CanSelectFeature = function (feature, layer) {
            return typeof feature.getProperties().uid !== "undefined";
        };
        this.onFeaturesSelected = function (featuresArray, coordinate) {
            var uids = {}, features, popupHtml = "", previousType = "";
            //this.ttipElement.tooltip('hide');
            features = featuresArray;
            if (features) {
                for (var i = 0; i < features.length; i++) {
                    var layerGroup = _this.selectFeatures.getLayer(features[i]).get("layerGroup");
                    var feature = _this.recordTypeResource.mapToIRecordTypeInfoClick(features[i].getProperties(), layerGroup);
                    var html = "";
                    var currentType = void 0;
                    if (_this.recordTypeResource.groupByRecordSubTypeCode(feature.recordType)) {
                        currentType = feature.layerGroup.layerType + (feature.recordSubTypeCode || "_");
                    }
                    else {
                        currentType = feature.layerGroup.layerType;
                    }
                    if (previousType !== currentType) {
                        //set the heading each time the record type/sub type changes            
                        popupHtml += "<h4>" + feature.heading + "</h4>";
                        previousType = currentType;
                    }
                    html = _this.recordTypeResource.getInfoClickHtmlTemplate(feature);
                    feature.data.css = "popupRecord";
                    if (feature.uid && !uids[feature.uid]) {
                        //stop duplicates
                        html = _this.replaceTokens(html, feature.data);
                        popupHtml += html;
                        uids[feature.uid] = 1;
                    }
                }
            }
            if (popupHtml) {
                _this.popupContent.html(popupHtml);
                _this.popupContainer.css('display', 'block');
                _this.overlay.setPosition(coordinate);
            }
            else {
                //log("no features selected");
            }
        };
        this.replaceTokens = function (html, data) {
            //go thru html string and replace any tokens with attribute values
            for (var attributeName in data) {
                if (data.hasOwnProperty(attributeName)) {
                    html = html.replace(new RegExp("\\[" + attributeName + "\\]", "g"), data[attributeName]);
                }
            }
            return html;
        };
        this.init();
    }
    return MapPopup;
}());
exports.MapPopup = MapPopup;
//# sourceMappingURL=MapPopup.js.map